import { useProjectForBudgetQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import type { Store } from "../store";

export const useFetchProject = (id: string, store: Store) => {
  const { data, loading, refetch } = useProjectForBudgetQuery({
    variables: { id },
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      store.setCategoriesWithoutBudgetItems({
        ourWorkCategories: data.ourWorkBudgetCategories || [],
        expenseCategories: data.expenseBudgetCategories || [],
      });

      if (data.project) {
        store.setProject(data.project);
      }

      store.lowestPossibleDate = new Date(
        data.projectDatesForBudgetChange.lowestPossibleDateForBudgetChange,
      );
      store.defaultDate = new Date(
        data.projectDatesForBudgetChange.defaultDateForBudgetChange,
      );
    },
    ...onError(),
  });

  store.refetch = refetch;

  store.setProjectLoading(loading);

  return { data, loading };
};
